export const prefixImgLink= 'https://hn.ss.bfcplatform.vn/pos/'
